const el = {
  layout: document.querySelector(".layout"),
};

const A11y = {

  init: () => {
    window.addEventListener("keydown", A11y.handleFirstTab);
  },

  handleFirstTab: (event) => {
    if (event.key === "Tab") {
      el.layout.classList.add("layout--a11y");

      window.removeEventListener("keydown", A11y.handleFirstTab);
      window.addEventListener("mousedown", A11y.handleMouseDownOnce);
    }
  },

  handleMouseDownOnce: () => {
    el.layout.classList.remove("layout--a11y");

    window.removeEventListener("mousedown", A11y.handleMouseDownOnce);
    window.addEventListener("keydown", A11y.handleFirstTab);
  },
};

export default A11y;